import produce from 'immer'

const defaultState = {
  isInitialized: false,
  isInitializing: false,
  isCheckingLogin: false,
  isLoggedIn: null,
  isLoggingIn: false,
  error: null,
  loginError: null,
  categoryIds: [],
  sectionModalOpen: false,
  selectedSectionId: '',
}

export default (state = defaultState, action) => produce(state, draft => {
  switch (action.type) {
  case 'INIT_DASHBOARD':
    draft.isInitializing = true
    return
  case 'CHECK_AUTH':
    draft.isCheckingLogin = true
    return
  case 'CHECK_AUTH_SUCCESS':
    draft.isCheckingLogin = false
    draft.isLoggedIn = true
    return
  case 'CHECK_AUTH_FAIL':
    draft.isCheckingLogin = false
    draft.isLoggedIn = false
    return
  case 'INIT_DASHBOARD_SUCCESS':
    draft.isInitializing = false
    draft.isInitialized = true
    draft.categoryIds = action.categories.map(c => c.id)
    draft.profile = action.profile
    return
  case 'INIT_DASHBOARD_FAIL':
    draft.isInitializing = false
    draft.error = action.error
    return
  case 'LOGIN':
    draft.isLoggingIn = true
    return
  case 'LOGIN_SUCCESS':
    draft.isLoggingIn = false
    draft.isLoggedIn = true
    return
  case 'LOGIN_FAIL':
    draft.loginError = action.error
    return

  case 'CREATE_GEO_CATEGORY_SUCCESS':
    draft.categoryIds = [...draft.categoryIds, action.category.id]
    return
  case 'DELETE_GEO_CATEGORY_SUCCESS':
    draft.categoryIds = draft.categoryIds.filter(cid => cid !== action.categoryId)
    return
  case 'SELECT_SECTION':
    draft.selectedSectionId = action.sectionId
    return
  case 'OPEN_SECTION_MODAL':
    draft.sectionModalOpen = true
    return
  case 'CLOSE_SECTION_MODAL':
    draft.sectionModalOpen = false
    return
  case 'LOGOUT_SUCCESS':
  case 'RESET_DASHBOARD':
    return defaultState
  }
})